module.exports = __webpack_public_path__ + "static/media/logo.6e67c2bb.png";